import { render } from "./WaitlistNav.vue?vue&type=template&id=30c3f72c&scoped=true"
import script from "./WaitlistNav.vue?vue&type=script&lang=js"
export * from "./WaitlistNav.vue?vue&type=script&lang=js"

import "./WaitlistNav.vue?vue&type=style&index=0&id=30c3f72c&scoped=true&lang=css"

import exportComponent from "/home/lexmodo/projects/waitlist/waitlist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30c3f72c"]])

export default __exports__